type Falsy = false | null | undefined | 0 | '';

export function isTruthy<T>(value: T | Falsy): value is Exclude<T, Falsy> {
	return !!value;
}
